import { TimeZone } from '@treadinc/horizon-api-spec';

type TimeZoneLookup = (latitude: number, longitude: number) => string;

let timeZoneLookupPromise: Promise<TimeZoneLookup> | null = null;

// The boundary data is ~90 KB, so it loads on first use instead of with the app.
const loadTimeZoneLookup = () => {
  timeZoneLookupPromise ??= import('@photostructure/tz-lookup').then(
    (module) => module.default,
  );

  return timeZoneLookupPromise;
};

const KNOWN_TIME_ZONES = new Set<string>(Object.values(TimeZone));

const isKnownTimeZone = (zone: string): zone is TimeZone => KNOWN_TIME_ZONES.has(zone);

/**
 * The IANA zone at a coordinate, or null for open water (the library answers with a
 * nautical `Etc/GMT±N` zone there) and for coordinates out of range.
 */
export async function lookupTimeZone(latitude: number, longitude: number) {
  const timeZoneLookup = await loadTimeZoneLookup();

  let zone: string;
  try {
    zone = timeZoneLookup(latitude, longitude);
  } catch {
    return null;
  }

  const isNauticalZone = zone.startsWith('Etc/');

  return !isNauticalZone && isKnownTimeZone(zone) ? zone : null;
}
